/**************************************************
 * Nombre:       Tarjeta_Oferta_Tiempo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import oferta from '../../Recursos/tpm_oferta.png'
import {theme} from "../../Tema";
import {KeyboardArrowRight} from "@mui/icons-material";
import {useCuentaRegresiva} from "../Secciones/Componentes/SubComponentes/Hooks/useCuentaRegresiva";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router";


const Tarjeta_Oferta_Tiempo = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const navigate = useNavigate();
    const [fecha, setFecha] = useState('')
    const {Reloj} = useCuentaRegresiva({fecha: fecha})

    useEffect(() => {

        setFecha(item.fechaOferta)

    }, [item])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                            <Typography sx={{fontSize: 16, fontWeight: 700, color: theme.palette.secondary.main}}>
                                {item.marca}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{
                                fontSize: !masSM ? 48 : 64,
                                fontWeight: 800,
                                color: theme.palette.primary.main,
                                lineHeight: 1.1
                            }}>
                                {item.nombre}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 2, px: 1}}>
                            <Typography sx={{fontSize: 18, fontWeight: 600, color: theme.palette.primary.main}}>
                                Corre a obtener el tuyo
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', px: 1, mt: 2}}>
                            <Reloj/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 4, px: 1}}>
                            <Button
                                onClick={() => navigate('/Detalle/' + item.id)}
                                color={'secondary'} sx={{px: 1, py: 0.8}}>
                                <Typography sx={{px: 2, fontSize: 14}}>
                                    Obtener Ahora
                                </Typography>
                                <IconButton
                                    sx={{backgroundColor: '#fff', p: 0.6}}><KeyboardArrowRight/></IconButton></Button>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'center'}}>
                    <img src={item.img} width={'90%'} height={'auto'}/>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Oferta_Tiempo